import _ from 'lodash';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import TicketCategoryContainer from '../../containers/Ticket/TicketCategory';
import FormTypeToSelect from "../form/FormTypeToSelect";

const styles = () => {
	return {
		fetching : {
			fontStyle : 'italic',
			padding : '10px 0px',
			color : '#777',
		},
	};
};

class TicketCategoryPicker extends PureComponent {
	state = {
		value : '',
	};

	componentDidMount () {
		if (_.isEmpty(this.props.ticketCategories)) {
			this.props.searchTicketCategories();
		} else {
			this.makeTicketCategoryOptions();
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const {ticketCategories} = this.props;

		if (!_.isEmpty(ticketCategories) && prevProps.ticketCategories !== ticketCategories) {
			this.makeTicketCategoryOptions();
		}
	}

	makeTicketCategoryOptions = () => {
		const {onlyShowParents} = this.props;

		if (onlyShowParents) {
			this.makeParentTicketCategoryOptions();
		} else {
			this.makeAllTicketCategoryOptions();
		}
	};

	makeAllTicketCategoryOptions = () => {

		const { ticketCategories} = this.props;

		const ticketCategoryMap = _.keyBy(ticketCategories, 'ticketCategoryId');
		const groupedByParentId = {};
		ticketCategories.forEach(ticketCategory => {
			const { ticketCategoryId, displayName, parentTicketCategoryIds } = ticketCategory;

			//- parent
			if (_.isEmpty(parentTicketCategoryIds)) {

				if (!groupedByParentId[ticketCategoryId]) {
					groupedByParentId[ticketCategoryId] = {
						options : [],
					};
				}
				groupedByParentId[ticketCategoryId].label = displayName;

			//- child
			} else {
				parentTicketCategoryIds.forEach(parentTicketCategoryId => {

					if (!groupedByParentId[parentTicketCategoryId]) {
						groupedByParentId[parentTicketCategoryId] = {
							options : [],
						};
					}

					const parent = ticketCategoryMap[parentTicketCategoryId] || {};

					groupedByParentId[parentTicketCategoryId].options.push({
						value : ticketCategoryId,
						label : `${parent.displayName} : ${displayName}`,
					});
				});
			}
		});


		const ticketCategoryOptions = _.sortBy(_.values(groupedByParentId), 'label').map(group => {
			group.options = _.sortBy(group.options, 'label');
			return group;
		});

		this.setState({ ticketCategoryOptions });
	};

	makeParentTicketCategoryOptions = () => {

		const { ticketCategories} = this.props;
		const ticketCategoryOptions = [];

		_.sortBy(ticketCategories, 'label').forEach(ticketCategory => {
			const { ticketCategoryId, displayName, parentTicketCategoryIds } = ticketCategory;

			//- child
			if (!_.isEmpty(parentTicketCategoryIds)) {
				return;
			}

			ticketCategoryOptions.push({
				value : ticketCategoryId,
				label : displayName,
			});
		});
		this.setState({ ticketCategoryOptions });
	};

	render () {
		const {classes} = this.props;
		const {ticketCategoryOptions} = this.state;

		if (_.isEmpty(ticketCategoryOptions)) {
			return (<div className={classes.fetching}>Fetching ticket categories...</div>);
		}

		return (
			<FormTypeToSelect
				{...this.props}
				options={ticketCategoryOptions}
				//onChange={this.onChange}
			/>
		);
	}
}

TicketCategoryPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	helpText : PropTypes.string,

	searchTicketCategories: PropTypes.func,
	ticketCategories : PropTypes.array,
	ticketSchemaMap : PropTypes.object,

	onlyShowParents : PropTypes.bool,
};

TicketCategoryPicker.defaultProps =  {
	label : 'Ticket Category',
	onlyShowParents : false,
};

export default _.flow([
	withStyles(styles),
	TicketCategoryContainer,
])(TicketCategoryPicker);